import * as Dialog from '@radix-ui/react-dialog';
import React from 'react';
import MainButton from '../MainButton/MainButton';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type AlertDialogProps = {
	label?: string;
	size?: 'sm' | 'md' | 'lg';
	text: string;
	icon?: IconProp;
	invert?: boolean;
	hideIcon?: boolean;
	open: boolean;
	setOpen: (open: boolean) => void;
};

const sizeClassMap = {
	sm: 'w-80',
	md: 'w-96',
	lg: 'w-[28rem]',
};

const AlertDialog: React.FC<AlertDialogProps> = ({
	label = 'Attention',
	text,
	size = 'md',
	icon = faWarning,
	invert = false,
	hideIcon = false,
	open,
	setOpen,
}) => {
	return (
		<Dialog.Root open={open} onOpenChange={setOpen}>
			<Dialog.Portal>
				<Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-30" />
				<Dialog.Content
					role="alertdialog"
					aria-modal="true"
					className={`
						fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
						bg-white rounded-lg p-6 shadow-lg
						${sizeClassMap[size]}
					`}
				>
					<Dialog.Title className="text-lg font-bold mb-4 flex items-center">
						{!hideIcon && (
							<FontAwesomeIcon icon={icon} className="mr-2 text-yellow-500" />
						)}
						{label}
					</Dialog.Title>

					<Dialog.Description className="mb-6">{text}</Dialog.Description>

					<div className="flex justify-end">
						<Dialog.Close asChild>
							<MainButton
								onClick={() => setOpen(false)}
								label="OK"
								size="lg"
								invert={invert}
							/>
						</Dialog.Close>
					</div>
				</Dialog.Content>
			</Dialog.Portal>
		</Dialog.Root>
	);
};

export default AlertDialog;
